<template>
  <SelectedClass />
</template>

<script>
import SelectedClass from '@/components/content/classes/SelectedClass.vue'

export default {
  name: 'Class',
  components: { SelectedClass }
}
</script>

<style scoped>

</style>
